import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RestAPIService } from './service/rest-api.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'openbanking';
  private sub: any;
  page: any;
  public xmlItems: any;  

  constructor(private _http: HttpClient, private cookieService: CookieService, private route: ActivatedRoute, private router: Router, private restapi: RestAPIService) {
    try {
      var temp = window.location.href.split('?');

      var temp1 = temp[1].split('=')[1];
      var temp2 = temp1.split('&')[0];
      //this.cookieService.set('Cookie', 'OB_Session=' + temp[1].split('=')[1]);
      localStorage.setItem('OB_Session', 'OB_Session=' + temp2); // sessionID
      localStorage.setItem('session', temp2); // sessionID

      var host = temp[1].split('&host=')[1]
      localStorage.setItem('host', host); // sessionID
    } catch (e) {
    }
  }

  // constructor(private _http: HttpClient) { this.loadXML(); }  
  ngOnInit() {
    this.router.navigate(['confirm/login']);
  }

  validateClient() {
    this.restapi.API_URL = 'https://' + localStorage.getItem('host');
    const cPath = "token";
    const bodyObj = {
    };
    this.restapi.postAPI(cPath, bodyObj).subscribe((data) => {
      try {
        if (data.ResponseCode === 'OK') {
          this.getConsentInfo()
        }
      } catch (e) {
      }
    });
  }
  getConsentInfo() {
    this.restapi.API_URL = 'https://' + localStorage.getItem('host');
    const cPath = "account-access-consents";
    const bodyObj = {
    };
    this.restapi.postAPI(cPath, bodyObj).subscribe((data) => {
      try {
        if (data.ResponseCode === 'OK') {
          this.generateJWT()
        }
      } catch (e) {
      }
    });
  }
  generateJWT() {
    this.restapi.API_URL = 'https://' + localStorage.getItem('host');
    const cPath = "generate-jwt";
    const bodyObj = {
    };
    this.restapi.postAPI(cPath, bodyObj).subscribe((data) => {
      try {
        if (data.ResponseCode === 'OK') {
          this.getConsentInfo();
          this.router.navigate(['confirm']);
        }
      } catch (e) {
      }
    });
  }

}